import formatter from "../../../constants/currencyFormatter"
import HighlightMatch from "../../../utilities/HighlightMatch"
import { DateTime } from "luxon"
import TxnType from "./TxnType"

export default function TxnRow({ txn, filter, handleClick = null }) {
  const isVinMatched = () => filter && txn?.attributes?.units?.some((unit) => unit?.vin?.toLowerCase()?.includes(filter?.toLowerCase()))

  const rowText = () => {
    if (isVinMatched()) {
      return txn?.attributes?.units?.find((unit) => unit?.vin?.toLowerCase()?.includes(filter?.toLowerCase()))?.vin
    } else if(txn?.attributes?.units?.length > 1) {
      return `${txn?.attributes?.units?.length} units`
    } else {
      return `${txn.attributes.units[0].make} ${txn.attributes.units[0].model}`
    }
  }

  return(
    <div
      className={`flex w-full items-center justify-between text-sm py-1 px-2 lg:hover:bg-grey-700 hover:cursor-pointer border-b-2 border-grey-700`}
      onClick={() => handleClick(txn)}
      data-testid="txn-row"
    >
      <div className="flex items-center">
        <div className="mr-2">
          <TxnType txn={txn} />
        </div>
        {<HighlightMatch
          str={DateTime.fromISO(txn.attributes['cdate']).toFormat('M/d/yy')}
          match={filter}
        />}
      </div>
      <div className="flex justify-center text-center p-2 truncate">
          <HighlightMatch
            str={rowText()}
            match={filter}
            truncate={true}
          />
      </div>
      <div className="flex justify-between items-center pl-4">
        <div className="flex justify-right items-center ">
          {<HighlightMatch str={formatter.format(txn.attributes.amount)} match={filter} />}
        </div>
      </div>
    </div>
  )
}